import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { WrapperCardKits } from "./styled";
import { useKits } from "../hooks";
import { TableKits } from "./TableKits";

export const Kits = () => {
  const { navigateKitsCreate } = useKits();

  return (
    <AdminMenuLayout pageDescription="Kits" title="Kits">
      <WrapperCardKits>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={navigateKitsCreate}
            >
              Agregar nuevo kit
            </Button>
          </Col>
        </Row>
        <TableKits />
      </WrapperCardKits>
    </AdminMenuLayout>
  );
};
